import { getPath, Path } from 'urlBuilder';

export const getWorkflowsLink = (companyId: string) => {
    return getPath(Path.companyWorkflows, companyId);
};
